import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import {
  ImageTransformer,
  unwrapMedia,
} from 'src/relay/Transformers/ImageTransformer'
import SmallPush, { SmallPushProps } from 'src/components/SmallPush'
import { SmallPushVariant } from 'src/components/SmallPush/types'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'

import { ImagePosition, SmallPushBlockProps } from './props'

const SmallPushBlock: FC<BlockProps<SmallPushBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: SmallPushProps = useMemo(
    () => ({
      title: data.title || '',
      ...(data.description && {
        richTextProps: RichTextTransformer(
          data.description,
          configuration,
          locale
        ),
      }),
      actionButtonProps: ButtonTransformer({
        data: data.cta,
        theme: data.theme?.data,
      }),
      variant:
        data.imagePosition === ImagePosition.Left
          ? SmallPushVariant.default
          : SmallPushVariant.imageLast,
      pictureProps: {
        imageProps: ImageTransformer(unwrapMedia(data.desktopImage), {
          tablet: '100vw, 75vw',
        }),
        mobileImageProps: ImageTransformer(unwrapMedia(data.mobileImage), {
          tablet: '100vw, 75vw',
        }),
      },
      color: getThemeColor(data.theme?.data),
    }),
    [configuration, data, locale]
  )

  return <SmallPush {...props} />
}

export default SmallPushBlock
